import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getTradersMarkUps({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_TRADERS_MARK_UPS_REQUEST')

        return axios
            .get(`/finances/margins${paginate}${query}`)
            .then(response => {
                commit('GET_TRADERS_MARK_UPS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_TRADERS_MARK_UPS_FAILURE')
                handleApiError(error, 'Pobranie narzutu handlowca nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateTradersMarkUp({ commit }, payload) {
        return axios
            .put(`/finances/margins/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Narzut handlowca został zaktualizowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja narzutu handlowca nie powiodła się.')

                return Promise.reject(error)
            })
    },
    setProductGroupFactorsFilters({ commit }, filters) {
        commit('SET_TRADERS_MARK_UPS_FILTERS', filters)
    },
    clearProductGroupFactorsFilters({ commit }) {
        commit('CLEAR_TRADERS_MARK_UPS_FILTERS')
    }
}